// extracted by mini-css-extract-plugin
export default {"screenArea":"Viewport_screenArea__KJ+wZ","visibleArea":"Viewport_visibleArea__E54ft","content":"Viewport_content__Lli7d"};